import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
} from "devextreme-react/data-grid";
import { formatMessage } from "devextreme/localization";
import { useSelector, useDispatch } from "react-redux";
import { showLeaveSummary } from "../../../redux/actions";
import { responseLeave } from "../../../redux/reducers";
import { useScreenSize } from "../../../utils/media-query";

import ToolbarBefore from "../../../components/toolbar-before/ToolbarBefore";
import ToolbarAfter from "./ToolbarAfter";
import { useAuth } from "../../../contexts/auth";

export default function LeaveSummaryTableList({
  onCellPrepared,
  dataGrid,
  middleware,
}) {
  const { user } = useAuth();
  const [year, setYear] = React.useState();
  const { isXSmall, isSmall } = useScreenSize();
  const dispatch = useDispatch();
  const { leaveSummary } = useSelector(responseLeave);

  const handleChangeSelectBox = async () => {
    const payload = {
      Year: Number(year),
      EmployeeOid: user?.EmployeeOid,
    };
    dispatch(showLeaveSummary(payload));
  };
  return (
    <>
      <DataGrid
        id="gridContainer"
        height={document.documentElement.offsetHeight - 189}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
        ref={(e) => {
          dataGrid.current = e;
        }}
        dataSource={leaveSummary}
        onCellPrepared={onCellPrepared}
      >
        {/* <SearchPanel
        visible={true}
        width={240}
        className="datagrid-toolbar-search-panel"
        placeholder="Search..."
      /> */}

        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />
        <Column
          caption={formatMessage("Year")}
          dataField="Year"
          dataType="string"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("DepartmentCode")}
          dataField="Employee.Department.DepartmentCode"
          dataType="string"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("DepartmentName")}
          dataField="Employee.Department.DepartmentName"
          dataType="string"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("EmployeeCode")}
          dataField="Employee.EmployeeCode"
          dataType="string"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("FullName")}
          dataField="Employee.FullName"
          dataType="string"
        />
        <Column
          caption={formatMessage("PositionName")}
          dataField="Employee.Position.PositionName"
          dataType="string"
        />
        <Column
          caption={formatMessage("DateIn")}
          dataField="Employee.DateIn"
          hidingPriority={isXSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("DateOut")}
          dataField="Employee.DateOut"
          hidingPriority={isXSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("LeaveSymbol")}
          dataField="LeaveSymbol"
          dataType="string"
          hidingPriority={isXSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("Total")}
          dataField="Total"
          dataType="string"
          hidingPriority={isXSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("Used")}
          dataField="Used"
          hidingPriority={isXSmall ? 5 : false}
        />
        <Column
          caption={formatMessage("Remain")}
          dataField="Remain"
          hidingPriority={isXSmall ? 5 : false}
        />
        <Column
          caption={formatMessage("Jan")}
          dataField="Jan"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Feb")}
          dataField="Feb"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Mar")}
          dataField="Mar"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Apr")}
          dataField="Apr"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("May")}
          dataField="May"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Jun")}
          dataField="Jun"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Jul")}
          dataField="Jul"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Aug")}
          dataField="Aug"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Sep")}
          dataField="Sep"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Oct")}
          dataField="Oct"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Nov")}
          dataField="Nov"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Dec")}
          dataField="Dec"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Toolbar className="datagrid-toolbar-actions">
          <Item
            location="before"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarBefore
              middleware={middleware}
              dataGrid={dataGrid}
              setYear={setYear}
              handleChangeSelectBox={handleChangeSelectBox}
            />
          </Item>
          <Item
            location="after"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarAfter middleware={middleware} dataGrid={dataGrid} />
          </Item>
        </Toolbar>
      </DataGrid>
    </>
  );
}
